import { render, staticRenderFns } from "./BannerSortOrderNameplate.vue?vue&type=template&id=a40016fa&lang=pug"
import script from "./BannerSortOrderNameplate.vue?vue&type=script&lang=js"
export * from "./BannerSortOrderNameplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports